import { useMemo } from "react"
import { useQuery } from "react-query"
import { getUsername } from "../../../service/authorization"
import { getSuppliers } from "../../../service/SupplierService"

function useOrderSearch(tunnelData) {
  const username = useMemo(() => getUsername(), [])

  const { data: suppliers } = useQuery({
    queryKey: ["query-suppliers"],
    queryFn: () => getSuppliers(tunnelData, username),
    refetchOnWindowFocus: false
  })

  function mapSuppliersToSelect (suppliers) {
    if (!suppliers) return []
    return suppliers.map((supplier) => {
      return {
        label: supplier.name,
        value: supplier.id
      }
    })
  }

  return {
    suppliers,
    mapSuppliersToSelect,
  }
}

export default useOrderSearch
